module.exports = __webpack_public_path__ + "static/media/GA_Feedback_2018.10.6.9506ee34.webp";